export const MobileMaxWidth: number = 760;
export const MobileBiggerWidth: number = 990;
export const ResizeMediumWidth: number = 1200;

export const MAX_IMAGE_SIZE_IN_BYTES = 1 * 1024 * 1024; //1MB
